import { render, staticRenderFns } from "./setuser.vue?vue&type=template&id=0274ed7e&scoped=true&"
import script from "./setuser.vue?vue&type=script&lang=js&"
export * from "./setuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0274ed7e",
  null
  
)

export default component.exports